<template>
    <section>
        <Sidebar />
        <Content class="create-endpoint-page">
            <h1><i class="fas fa-file-invoice" style="margin-right: 7px;"></i> Invoices</h1>

            <div class="col-md-12">
                <b-table
                    :data="data.length == 0 ? [] : data"
                    :bordered="true"
                    :striped="true"
                    :loading="isLoading">

                    <template slot-scope="props">
                        <b-table-column field="Type" label="Type" width="40" numeric>
                            <span>Email</span>
                        </b-table-column>

                        <b-table-column field="To" label="To">
                            {{ props.row.notification_to }}
                        </b-table-column>

                        <b-table-column field="date" label="Date" centered>
                            <small>{{new Date(props.row.created).toLocaleDateString()}}
                            {{new Date(props.row.created).toLocaleTimeString()}}</small>
                        </b-table-column>
                    </template>

                    <template slot="empty">
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <p>
                                    <b-icon
                                        icon="emoticon-sad"
                                        size="is-large">
                                    </b-icon>
                                </p>
                                <p>Nothing here.</p>
                            </div>
                        </section>
                    </template>
                </b-table>
            </div>
        </Content>
    </section>
</template>

<script>
import Sidebar from "../components/sidebar/Sidebar"
import Content from "../components/Content"
import {getJWTContent, getUserPlan} from "../logic/global"
import constants from '../constants'
import Plans from '../components/Plans'
import {getUserNotificationsSettings, updateUserNotificationsSettings, getUserAlerts} from '../logic/account'

export default {
    name: 'Invoices',
    components: {Sidebar, Content, Plans},
    data() {
        return {
            data: [],
        }
    },
    methods: {
       
    },
    mounted: function(){
        
    }
}
</script>

<style scoped>
  h1{margin-bottom: 24px;}
</style>